import { FC } from 'react';
import Interview from 'types/Interview';
import { getLocaleDate, getLocaleTime } from 'utils/time';
import { Container } from './components';
import NoAnswer from './NoAnswer';

type Props = {
  interview: Interview | undefined;
};
const WaitingMentee: FC<Props> = ({ interview }) => {
  const dateDifference = interview?.date
    ? new Date().getTime() - new Date(interview?.date).getTime()
    : undefined;

  return dateDifference && dateDifference < 0 ? (
    <Container>
      <p>
        Le mentor a proposé un entretien le{' '}
        {interview?.date && getLocaleDate(interview.date)} à{' '}
        {interview?.date && getLocaleTime(interview.date)}.
      </p>
      <p>Le mentoré doit maintenant accepter ou refuser l'entretien.</p>
    </Container>
  ) : (
    <NoAnswer interview={interview} />
  );
};

export default WaitingMentee;
